import { createSelector } from 'reselect'

import { selectContactsState } from './selectContactsState'

export const selectContactsLoading = createSelector(
  [selectContactsState],
  (state) => state.isLoading
)
